import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {GetMeetings as GetMeetingsQuery} from 'nutshell-graphql-types';

import GET_MEETINGS from '../queries/get-meetings.graphql';

export const useGetMeetingsList = (input: {
    entityIds?: string[];
    isShowingArchived: boolean;
    meetingTypes?: string[];
}) => {
    const {data, error, loading, refetch, networkStatus} = useQuery<
        GetMeetingsQuery,
        Record<any, any>
    >(GET_MEETINGS, {
        fetchPolicy: 'cache-and-network',
        variables: {
            entityIds: input.entityIds,
            archived: input.isShowingArchived,
            meetingTypes: input.meetingTypes,
        },
    });

    const meetings = data ? data.meetings : null;

    return {
        meetings,
        isLoading: loading,
        isFirstLoad: loading && networkStatus !== 3,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        refetchMeetings: refetch,
    };
};
